/** GRAM formatting helpers for the Arena (the hero look itself is drawn by common/HeroFigure). */

/** "0.5" → "0.5", 0.95 → "0.95", 1.9000001 → "1.9" (max 4 decimals). */
export function formatGram(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return String(Math.round(n * 10000) / 10000);
}

/** Prize of a stake: 2·stake·(1 − commission%). */
export function stakePrize(stake, commissionPercent) {
  const s = Number(stake) || 0;
  const c = Number(commissionPercent) || 0;
  return 2 * s * (1 - c / 100);
}
